<template lang="pug">
div
  v-row(no-gutters)
    v-col(cols="9")
      div.d-flex.align-center.my-5(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      v-tabs(v-else v-model="inventoryTab" color="basic700" :height="44" show-arrows active-class="font-semibold" @change="tabChanged")
        v-tab.px-4(v-for="item in inventoryItems" :key="item.id" style="min-width: unset")
          div.text-sm.font-medium.text-none {{ item.name }}
    v-col(cols="3" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(v-if="!showSearchField" icon @click="openAddNewListDialog = true")
          v-icon(color="neutral700" size="23") mdi-plus
        slot(name="search")
  v-divider

  .dialogs
    add-edit-list-dialog(v-if="openAddNewListDialog" :open.sync="openAddNewListDialog" @close="fetchInventoryList")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddEditListDialog from '@/components/clinic/dialogs/purchasehub/AddEditListDialog.vue'

export default {
  components: {
    AddEditListDialog
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    attach: {
      type: Boolean,
    },
    showSearchField: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    openDialog: false,
    inventoryList: [],
    inventoryTab: 0,
    defaultItems: [
      { id: 'all', name: 'All', iconColor: 'success500' },
      { id: 'preorder', name: 'Pre-order', iconColor: 'info500' },
      { id: 'orderSoon', name: 'Order soon', iconColor: 'warning500' },
      { id: 'outOfStock', name: 'Out of stock', iconColor: 'danger500' }
    ],
    openAddNewListDialog: false
  }),
  mounted () {
    this.inventoryTab = 2
    this.tabChanged(2)
    this.fetchInventoryList()
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    inventoryItems () {
      return [...this.defaultItems, ...this.inventoryList]
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchInventoryList () {
      this.isFetching = true
      const params = {
        page_size: -1,
      }
      this.$axios.get(`/clinics/${this.company.slug}/inventory_lists`, { params })
        .then(resp => {
          const results = resp.data.results.map(item => {
            return {
              ...item,
              iconColor: 'info500'
            }
          })
          this.inventoryList = results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    tabChanged (tab) {
      let selected = this.inventoryItems[tab]
      this.selectItem(selected)
    },
    selectItem (item) {
      this.$emit('input', item)
      this.$emit('change')
    },
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
</style>